<template>
    <div class="slide-wrapper">
        <a-modal
            class="edit-slide-user"
            :visible="visible"
            :title="$t('program.slide_user_admin'/*试片试管理员*/ )"
            :width="400"
            :maskClosable="false"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel">
            <a-form :form="form">
                <a-form-item style="display:none;">
                    <a-input v-decorator="['admin_id']"></a-input>
                </a-form-item>
                <a-form-item style="width:100%;" :label="$t('program.login_account'/*登录账号*/ )">
                    <a-input :placeholder="$t('program.please_enter_login_account'/*请输入登录账号*/ )" style="width:100%;" v-decorator="['user_name', { rules: [{ required: true, message: $t('program.please_enter_login_account'/*请输入登录账号*/ ) }] }]"></a-input>
                </a-form-item>
                <a-form-item style="width:100%;" :label="$t('program.login_password'/*登录密码*/ )">
                    <a-input :placeholder="$t('program.please_enter_login_password'/*请输入登录密码*/ )" style="width:100%;" v-decorator="['password', { rules: [{ required: false, message: $t('program.please_enter_login_password'/*请输入登录密码*/ ) }] }]"></a-input>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
import pick from 'lodash.pick';
const fileds = ['user_name', 'password', 'admin_id'];
export default {
    name: 'editSpeakModal',
    props: {
    },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this)
        };
    },
    methods: {
        showFun(data) {
            this.visible = true
            if (data) {
                this.form.setFieldsValue(pick(data, fileds))
                this.form.setFieldsValue({
                    admin_id: data.id
                })
            }
        },
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = true;
                    this.$request.post({ url: 'addSlideUser', data: values }).then(res => {
                        this.$message.success(res.message);
                        this.confirmLoading = false;
                        this.$emit('reset')
                        this.handleCancel();
                    }).finally(() => {
                        this.confirmLoading = false;
                    });
                }
            });
        },
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        }
    },
    created () {
        fileds.forEach(v => this.form.getFieldDecorator(v))
    }
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-modal-body {
    max-height: 72vh;
    overflow-y: auto;
}
</style>